import qs        from 'qs';
import navigator from './navigator';

const getCurrentSearchObject = () => {

    const currentSearchString = window.location.search.replace(/.*\?/, '');

    return qs.parse(currentSearchString);
};

export function setQueryParam(key, value) {

    const basePageUrl = window.location.pathname.replace(/\?.*/, '');

    const newSearchString = qs.stringify({ ...getCurrentSearchObject(), [key]: value}, { encode: false });

    navigator.push(`${basePageUrl}?${newSearchString}`);
}

export function getQueryParam(key) {

    return getCurrentSearchObject()[key];
}


// WEBPACK FOOTER //
// ./services/queryString.js